import { css } from '@/styled-system/css';

/**
 * Using 'justify-self: flex-end' to allow as much of the photo to be clickable as
 * possible (CDS-1777)
 */
export const propertyCardPhotoFooterStyles = css.raw({
  gridArea: 'photo-bottom',
  justifySelf: 'flex-end',
  zIndex: 1,
});
